// Products reviewed in single-product review posts. Used for SoftwareApplication JSON-LD.
export interface ReviewedProduct {
  name: string;
  applicationCategory: string;
  operatingSystem?: string;
  url?: string;
}

const map: Record<string, ReviewedProduct> = {
  p02: {
    name: "HubSpot CRM",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web, iOS, Android",
    url: "https://www.hubspot.com/products/crm",
  },
  p04: {
    name: "Pipedrive",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web, iOS, Android",
    url: "https://www.pipedrive.com/",
  },
  p05: {
    name: "Zoho CRM",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web, iOS, Android",
    url: "https://www.zoho.com/crm/",
  },
  p08: {
    name: "Close CRM",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web, iOS, Android",
    url: "https://close.com/",
  },
  p10: {
    name: "Salesforce Starter",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web, iOS, Android",
    url: "https://www.salesforce.com/starter/",
  },
  p13: {
    name: "Freshsales",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web, iOS, Android",
    url: "https://www.freshworks.com/crm/sales/",
  },
  p17: {
    name: "Insightly",
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web, iOS, Android",
    url: "https://www.insightly.com/",
  },
};

export function getReviewedProduct(postId: string): ReviewedProduct | undefined {
  return map[postId];
}
